var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageRechargeMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43.0003,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6673 15.771C25.6024 13.9872 25.381 12.9065 24.6244 12.1513C23.5546 11.0835 21.8327 11.0835 18.3891 11.0835C14.9454 11.0835 13.2236 11.0835 12.1538 12.1513C11.084 13.2192 11.084 14.9378 11.084 18.3752V24.6252C11.084 28.0625 11.084 29.7811 12.1538 30.849C13.2236 31.9168 14.9454 31.9168 18.3891 31.9168C21.8327 31.9168 23.5546 31.9168 24.6244 30.849C25.381 30.0938 25.6024 29.0132 25.6673 27.2293",
    stroke: "#FFC000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.334 28.7915H19.4173",
    stroke: "#FFC000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.666 21.4903V21.4997M29.883 26.1782C31.139 24.9786 31.916 23.3213 31.916 21.4907C31.916 19.6602 31.139 18.0029 29.883 16.8032M27.7493 19.147C28.3774 19.7468 28.7659 20.5754 28.7659 21.4907C28.7659 22.406 28.3774 23.2347 27.7493 23.8345",
    stroke: "#FFC000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 11.0835L15.3427 11.6398C15.5436 12.8453 15.6441 13.448 16.0575 13.8148C16.4887 14.1974 17.1001 14.2085 18.375 14.2085C19.6499 14.2085 20.2612 14.1974 20.6925 13.8148C21.1059 13.448 21.2064 12.8453 21.4073 11.6398L21.5 11.0835",
    stroke: "#FFC000",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 23.7628C20.7517 24.7039 19.845 25.3333 18.8092 25.3333C17.2365 25.3333 15.9615 23.8824 15.9615 22.0926V20.2407C15.9615 18.4509 17.2365 17 18.8092 17C19.845 17 20.7517 17.6294 21.25 18.5706M15 21.1667H19.0866",
    stroke: "#FFC000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRechargeMobile);
export default __webpack_public_path__ + "static/media/imageRechargeMobile.388c3fc65189a09161f4ba867bddf07f.svg";
export { ForwardRef as ReactComponent };